import { NgModule } from "@angular/core";
import { GlobalMaterialModules } from "../material-modules";
import { CommonModule } from "@angular/common";
import { LineChartComponent } from './line-chart/line-chart.component';
import * as PlotlyJS from 'plotly.js-dist-min';
import { PlotlyModule } from 'angular-plotly.js';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TreemapChartComponent } from './treemap-chart/treemap-chart.component';
import { CogsTreemapChartComponent } from "./cogs-treemap-chart/cogs-treemap-chart.component";
import { FeedbackDialogComponent } from './feedback-dialog/feedback-dialog.component';
import { RouterModule } from "@angular/router";
import { LhDropdownSelectorComponent } from "./dropdown-selector/lh-dropdown-selector.component";
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { UomToggleComponent } from "./uom-toggle/uom-toggle.component";
import { CurrencyToggleComponent } from "./currency-toggle/currency-toggle.component";
import { LhLvcRequestButtonComponent } from "./lvc-request-button/lh-lvc-request-button.component";
import { CHART_RELEVANT_PLOTLY_CONFIG } from './plotly-chart-config';
PlotlyModule.plotlyjs = PlotlyJS;
PlotlyJS.setPlotConfig(CHART_RELEVANT_PLOTLY_CONFIG);

@NgModule({
    declarations: [
        TreemapChartComponent,
        CogsTreemapChartComponent,
        FeedbackDialogComponent,
        LineChartComponent,
        LhDropdownSelectorComponent,
        UomToggleComponent,
        CurrencyToggleComponent,
        LhLvcRequestButtonComponent
    ],
    imports: [
        ...GlobalMaterialModules,
        NgxMatSelectSearchModule,
        PlotlyModule,
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        ...GlobalMaterialModules,
        TreemapChartComponent,
        CogsTreemapChartComponent,
        FeedbackDialogComponent,
        LineChartComponent,
        LhDropdownSelectorComponent,
        UomToggleComponent,
        CurrencyToggleComponent,
        LhLvcRequestButtonComponent,
        PlotlyModule
    ]
})
export class LhCommonsModule { }